import { render, staticRenderFns } from "./ClubInfoModalExpansionPanels.vue?vue&type=template&id=35f6833c&"
import script from "./ClubInfoModalExpansionPanels.vue?vue&type=script&lang=js&"
export * from "./ClubInfoModalExpansionPanels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35f6833c')) {
      api.createRecord('35f6833c', component.options)
    } else {
      api.reload('35f6833c', component.options)
    }
    module.hot.accept("./ClubInfoModalExpansionPanels.vue?vue&type=template&id=35f6833c&", function () {
      api.rerender('35f6833c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/Club/components/dependencies/ClubInfoModal/components/common/ClubInfoModalExpansionPanels.vue"
export default component.exports